import { SignInWithJCAPI } from 'client/util/Constants';
import CollectionApi from 'client/api/v2/CollectionApi';

class DevicesApi extends CollectionApi {
  constructor() {
    super('/api/v2/devices', {
      skip: 0,
      limit: 50,
    });
    this.signInURL = `${this.baseUrl}/settings/${SignInWithJCAPI.signin}`;
  }

  fetchOsDistribution() {
    return this.axios.get(`${this.baseUrl}/os_aggregation/`);
  }

  fetchOsDistributionAccordingLastContact(days) {
    return this.axios.get(`${this.baseUrl}/os_aggregation?lastContactWithinDays=${days}`);
  }

  fetchSignInWithJCSettings() {
    return this.axios.get(this.signInURL);
  }

  async updateSignInWithJCSettings(payload) {
    await this.initialize();
    return this.axios.put(this.signInURL, payload);
  }
}
export default new DevicesApi();
